export const styles = {
  notificationRoot: (theme) => ({
    zIndex: 9999999999,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'kit.background.middlepurple',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    letterSpacing: 'normal',
    paddingX: 2,
    paddingY: 1,
  }),
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: (theme) => ({
    marginRight: 1,
    color: 'kit.text.main',
    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
    [theme.breakpoints.up('xl')]: {
      display: 'block',
    },
  }),
  textDesktop: (theme) => ({
    color: 'kit.text.main',
    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
    [theme.breakpoints.up('xl')]: {
      display: 'block',
      lineHeight: '21px',
    },
  }),
  buttonDesktop: (theme) => ({
    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
    [theme.breakpoints.up('xl')]: {
      display: 'block',
      paddingY: '8px',
      paddingX: '16px',
      fontSize: '13px',
      lineHeight: '13px',
      borderRadius: '12px',
    },
  }),
  textMobile: (theme) => ({
    color: 'kit.text.main',
    [theme.breakpoints.down('xl')]: {
      display: 'block',
    },
    [theme.breakpoints.up('xl')]: {
      display: 'none',
    },
  }),
  buttonMobile: (theme) => ({
    [theme.breakpoints.down('xl')]: {
      display: 'block',
      paddingY: '6px',
      paddingX: '8px',
      fontSize: '12px',
      lineHeight: '14px',
      minWidth: '39px',
    },
    [theme.breakpoints.up('xl')]: {
      display: 'none',
    },
  }),
};
